var _clipPath;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRheinbahnLogoTextOnly(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 55,
    viewBox: "0 0 802 154",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "ArtBoard1",
    transform: "matrix(1.00185,0,0,1.02644,0,0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 799.823,
    height: 150.033,
    style: {
      fill: "none"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 799.823,
    height: 150.033
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.998156,0,0,0.97424,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-194.6,-344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M494.6,393.3C494.6,374.7 478.2,371.7 463.2,371.7L442.5,371.7L427.5,460.4L446.2,460.4L452.4,423.7L454.9,423.7C463.3,423.7 464.4,426 467,438.8L471.3,460.4L490.9,460.4L484.7,434.7C482.2,424 480.5,420 474.8,417.5L474.8,417.2C486,415.6 494.6,407.9 494.6,393.3ZM458.3,410.5C457,410.5 455.9,410.5 454.5,410.4L458.7,386L461.9,386C470.4,386 476.3,388.5 476.3,396.8C476.2,406.8 468.8,410.5 458.3,410.5Z",
    style: {
      fill: "currentColor",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-194.6,-344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M544.5,393.1C536.1,393.1 529.4,398.2 525.6,404.8L525.3,404.8C526.6,400.2 528.2,392 533.1,364.4L514.8,364.4L498.4,460.5L516.7,460.5L520.5,438.9C523.6,421.7 526.1,407.8 536.1,407.8C540.3,407.8 542.2,411.2 542.2,416.2C542.2,418.5 541.6,422.9 540.9,426.5L534.9,460.6L553,460.6L558.7,427.9C559.5,423.4 560.5,416.7 560.5,411.8C560.5,399.5 554.2,393.1 544.5,393.1Z",
    style: {
      fill: "currentColor",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-194.6,-344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M601.9,393.1C581.2,393.1 569,410.5 569,432.3C569,452 580.3,462.2 599.8,462.2C605,462.2 610.2,461.6 614.8,460L617.2,445.8C612.4,447.5 607.7,448.3 602.5,448.3C592.7,448.3 586.1,443.8 586.1,434.6C586.1,434.1 586.1,433.3 586.2,432.7L623.7,432.7C624.7,428.5 625.5,423.5 625.5,419.4C625.4,403.4 618.5,393.1 601.9,393.1ZM609.6,420.9L587.1,420.9C588.6,412.4 593.7,405.3 601.5,405.3C608.2,405.3 610.1,410.5 610.1,416.5C610.1,417.7 610,419.5 609.6,420.9Z",
    style: {
      fill: "currentColor",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-194.6,-344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M645.2,369.9L642.8,385.2L660.9,385.2L663.4,369.9L645.2,369.9Z",
    style: {
      fill: "currentColor",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-194.6,-344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M630,460.4L648.3,460.4L659.5,394.6L641.3,394.6L630,460.4Z",
    style: {
      fill: "currentColor",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-194.6,-344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M708,393.1C700.4,393.1 693.6,397.5 689.2,406.1L688.9,406.1C689.7,402.7 690.3,397.6 690.6,394.7L673.9,394.7C673.5,399.5 672.8,405.1 672,409.4C668.9,426.4 666.2,443.5 663.1,460.5L681.4,460.5L685.2,438.9C688.3,421.7 690.8,407.6 700.8,407.6C705,407.6 706.9,411 706.9,416C706.9,418 706.3,422.6 705.6,426.4C703.7,437.8 701.7,449.2 699.6,460.5L717.7,460.5L723.4,427.8C724.2,423.2 725.2,416.1 725.2,411.5C725.3,398.9 718.3,393.1 708,393.1Z",
    style: {
      fill: "currentColor",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-194.6,-344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M775.9,393.1C769.3,393.1 763.7,396.5 759.9,402.6L759.6,402.6C760.7,398.2 762.1,392.6 767.1,364.3L748.8,364.3L732.4,460.4L749.7,460.4L751.5,450.4L751.8,450.4C753.8,456.9 757.9,462.1 766.4,462.1C784.7,462.1 794.4,440.6 794.4,418.5C794.3,403.6 789.2,393.1 775.9,393.1ZM761.9,447.6C755.3,447.6 753.8,441.8 753.8,434.9C753.8,421.6 759.4,406.3 768,406.3C774.6,406.3 776.3,411.6 776.3,419.4C776.3,433.1 770.3,447.6 761.9,447.6Z",
    style: {
      fill: "currentColor",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-194.6,-344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M833.1,393.1C826.7,393.1 819.6,394 813.5,396.2L812.2,409.7C817.7,407.2 823.9,406.1 829.4,406.1C837.4,406.1 840.8,409.3 840.8,416.5C840.8,417.4 840.7,419 840.4,420.1C837.9,419.8 834.2,419.6 831.2,419.6C812.6,419.6 800.7,427.2 800.7,442.9C800.7,454.7 808.2,461.7 818.1,461.7C826.6,461.7 832.5,457.2 836.2,450.6L836.5,450.6C836.1,453.7 836,456.8 835.9,460.5L851.9,460.5C851.9,456.7 852.2,451.5 853.4,444.2C854.5,437.3 857.5,420.9 857.5,414.2C857.5,400.2 848.9,393.1 833.1,393.1ZM825.2,449C820.6,449 817.2,446.3 817.2,440.7C817.2,433.8 821.8,429.9 833.6,429.8C835.1,429.8 837.5,429.9 839.1,430.2C837.8,442 832.7,449 825.2,449Z",
    style: {
      fill: "currentColor",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-194.6,-344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M910.8,393.1C902.4,393.1 895.7,398.2 891.9,404.8L891.6,404.8C892.9,400.2 894.5,392 899.4,364.4L881,364.4L864.6,460.5L882.9,460.5L886.7,438.9C889.8,421.7 892.3,407.8 902.3,407.8C906.5,407.8 908.4,411.2 908.4,416.2C908.4,418.5 907.8,422.9 907.1,426.5L901.1,460.6L919.2,460.6L924.9,427.9C925.7,423.4 926.7,416.7 926.7,411.8C926.8,399.5 920.6,393.1 910.8,393.1Z",
    style: {
      fill: "currentColor",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-194.6,-344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M978.7,393.1C971.1,393.1 964.3,397.5 959.9,406.1L959.6,406.1C960.4,402.7 961,397.6 961.3,394.7L944.6,394.7C944.2,399.5 943.5,405.1 942.7,409.4C939.6,426.4 936.9,443.5 933.8,460.5L952.1,460.5L955.9,438.9C959,421.7 961.5,407.6 971.5,407.6C975.7,407.6 977.6,411 977.6,416C977.6,418 977,422.6 976.3,426.4C974.4,437.8 972.4,449.2 970.3,460.5L988.4,460.5L994.1,427.8C994.9,423.2 995.9,416.1 995.9,411.5C996,398.9 989,393.1 978.7,393.1Z",
    style: {
      fill: "currentColor",
      fillRule: "nonzero"
    }
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRheinbahnLogoTextOnly);
export default __webpack_public_path__ + "static/media/rheinbahn-logo-text-only.228941ac41cb49c472b30329770d4dc3.svg";
export { ForwardRef as ReactComponent };